// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentEligibilityModel {
    static getAttributeTypeMap() {
        return EnrollmentEligibilityModel.attributeTypeMap;
    }
}
EnrollmentEligibilityModel.discriminator = undefined;
EnrollmentEligibilityModel.attributeTypeMap = [
    {
        "name": "status",
        "baseName": "status",
        "type": "EnrollmentStatus"
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": "Array<EnrollmentConditionTypeModel>"
    }
];
//# sourceMappingURL=enrollmentEligibilityModel.js.map